export const paperStyles = (anchorMenu) => {
  return {
    opacity: anchorMenu ? 1 : 0,
    transform: 'none',
    transition: 'opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 133ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  }
}
